export const SHIPPING_OPTIONS_LOGO_SET = ["assets/images/svg/logos/GLS.svg", "assets/images/svg/logos/Rhenus.svg"];
